import {
  FETCH_CAMPAIGNS,
  DELETE_CAMPAIGN,
  CREATE_CAMPAIGN,
  FETCH_CAMPAIGN,
  UPDATE_CAMPAIGN,
  FETCH_PREVIEW,
  SEND_CAMPAIGN
} from "./types";
import actions from "./actions";
import {
  errorMutations,
  loadingMutations,
  replaceOrSetArrayObjectsValue,
  resetErrorsAndLoading,
  setter,
  getter,
  metadataSetter
} from "@/store/utils";
import { sortSearchPaginateMutations } from "@/store/common/mutations";
import {
  paginationFilterSortGetters,
  sortSearchPaginateGetters
} from "@/store/common/getters";
import { paginationFilterSortInitialObject } from "@/store/constants";

const state = {
  isLoading: false,
  errors: null,
  campaignsList: [],
  previews: {},
  ...paginationFilterSortInitialObject
};

const getters = {
  getFilteredDeletedCampaigns: state =>
    state.campaignsList.filter(c => c.deleted === null),
  getCampaign: state => id => state.campaignsList.filter(c => c.id === id)[0],
  getPreview: state => id => state.previews[id],
  isCampaignFrozen: (state, getters) => id => {
    const campaign = getters.getCampaign(id);
    return !!(campaign && campaign.mailed);
  },
  canSendCampaign: (state, getters) => id => {
    const campaign = getters.getCampaign(id);

    if (!campaign) {
      return false;
    }

    return (
      campaign.tags.length > 0 &&
      campaign.mailers.length > 0 &&
      !getters.isCampaignFrozen
    );
  },

  campaignsList: getter("campaignsList"),
  isLoading: getter("isLoading"),
  itemsPerPage: getter("itemsPerPage"),
  currentPage: getter("currentPage"),
  totalPages: getter("totalPages"),
  ...sortSearchPaginateGetters,
  ...paginationFilterSortGetters
};

const mutations = {
  [FETCH_CAMPAIGNS.success](state, { payload }) {
    setter("campaignsList", payload.items)(state);
    metadataSetter(payload, state, ["pagination", "sort", "filters"]);
    resetErrorsAndLoading(state);
  },

  [DELETE_CAMPAIGN.success](state, { payload }) {
    const updList = state.campaignsList.filter(item => item.id !== payload);
    setter("campaignsList", updList)(state);
    resetErrorsAndLoading(state);
  },

  [CREATE_CAMPAIGN.success](state, { payload }) {
    state.campaignsList.push(payload);
    resetErrorsAndLoading(state);
  },

  [FETCH_CAMPAIGN.success](state, { payload }) {
    replaceOrSetArrayObjectsValue(
      state,
      "campaignsList",
      "id",
      payload.id,
      payload
    );
    resetErrorsAndLoading(state);
  },

  [UPDATE_CAMPAIGN.success](state, { payload }) {
    replaceOrSetArrayObjectsValue(
      state,
      "campaignsList",
      "id",
      payload.id,
      payload
    );
    resetErrorsAndLoading(state);
  },

  [FETCH_PREVIEW.success](state, { payload }) {
    const { preview, id } = payload;
    setter(id, { ...preview })(state.previews);
    resetErrorsAndLoading(state);
  },

  [SEND_CAMPAIGN.success](state) {
    resetErrorsAndLoading(state);
  },

  ...sortSearchPaginateMutations,
  ...loadingMutations([
    FETCH_CAMPAIGNS.request,
    DELETE_CAMPAIGN.request,
    CREATE_CAMPAIGN.request,
    FETCH_CAMPAIGN.request,
    FETCH_PREVIEW.request,
    SEND_CAMPAIGN.request,
    UPDATE_CAMPAIGN.request
  ]),
  ...errorMutations([
    FETCH_CAMPAIGNS.error,
    DELETE_CAMPAIGN.error,
    CREATE_CAMPAIGN.error,
    FETCH_CAMPAIGN.error,
    FETCH_PREVIEW.error,
    SEND_CAMPAIGN.error,
    UPDATE_CAMPAIGN.error
  ])
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
